import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új eszköz',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "name",
                label: "Megnevezés",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "type",
                label: "Típus",
                visibility: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getInstrumentTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "placeMeasurement",
                label: "Vizsgálat helyszíne",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "producer",
                label: "Gyártó",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "productionTime",
                label: "Gyártási idő",
                filter: {
                    type: "simple",
                },
                visibility: true,
                slot_name: "productionTime_format",
                formType: 'date',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "serialNumber",
                label: "Gyári szám",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "code",
                label: "Egyedi azonosító",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "authenticationTimeFrom",
                label: "Hitelesítési idő (mettől)",
                filter: {
                    type: "simple",
                },
                visibility: true,
                slot_name: "authenticationTimeFrom_format",
                formType: 'date',
                formSize: 4,
                formVisible: true
            },
            {
                name: "authenticationTimeTo",
                label: "Hitelesítési idő (meddig)",
                filter: {
                    type: "simple",
                },
                visibility: true,
                slot_name: "authenticationTimeTo_format",
                formType: 'date',
                formSize: 4,
                formVisible: true
            },
            {
                name: "certificationBody",
                label: "Hitelesítő szerv",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true
            },
            {
                name: "siteId",
                label: "siteId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "companyId",
                label: "companyId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "deleted",
                label: "deleted",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "createdOn",
                label: "createdOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "createdBy",
                label: "createdBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
